import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClubService } from 'app/shared/services/club/club.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

export interface DialogData {
  clubCode: string;
}

@Component({
  selector: 'app-open-dialog-choose-image-from-club',
  templateUrl: './open-dialog-choose-image-from-club.component.html',
  styleUrls: ['./open-dialog-choose-image-from-club.component.scss']
})
export class OpenDialogChooseImageFromClubComponent extends SubscriptionBaseComponent implements OnInit {
  imageForm: UntypedFormGroup;
  images: any[] = [];
  imageSelected = null;

  isLoadingAllImages = false;

  color: ThemePalette = 'primary';

  constructor(
    public dialogRef: MatDialogRef<OpenDialogChooseImageFromClubComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: UntypedFormBuilder,
    private clubService: ClubService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
  }

  initSub() {
    this.subscription.add(

      this.clubService.getAllImagesByClub(this.data.clubCode).subscribe(images => {
        images.map(image => {
          let oneImage = {
            offerKey: image,
            isSelected: false
          }
          this.images.push(oneImage);
        })
        this.isLoadingAllImages = false;
      })
    )
  }

  confirm(): void {

    this.dialogRef.close(this.imageSelected);
  }

  chooseImage(image, event) {
    this.images.map(oneImage => {
      oneImage.isSelected = false;
    })

    image.isSelected = event;
    if (image.isSelected) {
      this.imageSelected = image.offerKey;
    } else {
      this.imageSelected = null;
    }
  }

}
